// extracted by mini-css-extract-plugin
export var container = "styles-module__container___LDHeQ";
export var headingText = "styles-module__headingText___hrnD9";
export var image = "styles-module__image___pC_Nq";
export var subText = "styles-module__subText___lyVdL";